export default __webpack_public_path__ + "static/media/AcumenFin-SLogo.25e2f14c.png";